var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Tessellating tiles")]),_c('p',[_vm._v("How many ways can one tessellate tiles on a plane?")]),_c('h3',[_vm._v("using regular polygons")]),_c('regular-polygon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }